import React, { useState, useEffect, useContext, useRef } from "react";

import { useForm } from "react-hook-form";
import { IoCloseOutline } from "react-icons/io5";
import { RecordStatusEnum } from "../../../enum/enum";
import masterApi from "../../../services/masterApi";
import { IoCheckmarkOutline } from "react-icons/io5";
import { SecondStepperCont } from "./SecondStepperCont";
import { toast } from 'react-toastify';
import { RoleContext } from "./roleContext";

export const RoleForm = ({ closePopup, roleid, viewOnly,loadRoleList, fromCopy}) => {
  const [isStepperCont1Visible, setIsStepperCont1Visible] = useState(true);
  const [isStepperCont2Visible, setIsStepperCont2Visible] = useState(false);
  const role = useRef("");
  const [permissionValidator, setPermissionValidator] = useState(null);
  const {validatePermissions, roleFunctionalities, expandedData, saveRolls} = useContext(RoleContext);


  // const nextSection = () => {
  //   setIsStepperCont1Visible(false);
  //   setIsStepperCont2Visible(true);
  // }

  const nextSection = async () => {
    const isValid = await trigger(["roleName", "recordStatus"]); // validate required fields
    if (isValid) {
      setIsStepperCont1Visible(false);
      setIsStepperCont2Visible(true);
    }
  };

  const previousSection = () => {
    setIsStepperCont2Visible(false);
    setIsStepperCont1Visible(true);
  }
  // Initialize React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger
  } = useForm();
  const [saveFunction, setSaveFunction] = useState(null);
  // Submit handler
  const onFormSubmit = async (data) => {
    


  // Check permissions before DB call
  if (!validatePermissions()) {
    toast.error("Please select at least one permission", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }

    // debugger;
    if (roleid && !fromCopy) {
      data.roleid = roleid;
      // debugger;
      const response = await masterApi.updateRole(data);
      console.log(response);
      if (response?.ok) {
        saveRolls(roleid, roleFunctionalities, expandedData);
        //loadRoleList();
        closePopup();
        toast.success("Role updated successfully", {
          position: "top-right",
          autoClose: 2000,
        });
      }
      else{
        toast.error("Error updating role", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    } else {
      if(data.roleName === role.current){
        toast.error("Role name already exists", {
          position: "top-right",
          autoClose: 2000,
        });
      }else{
        try{
          const response = await masterApi.createRole(data);
          console.log(response);
          if (response?.data?.ok) {
            toast.success("Role created successfully", {
              position: "top-right",
              autoClose: 2000,
            });
            saveRolls(response?.data?.role?.id, roleFunctionalities, expandedData);
            //loadRoleList();
            closePopup();
          }
          else{
            toast.error("Error creating role", {
              position: "top-right",
              autoClose: 2000,
            });
          }
        }catch(error){
          toast.error("Error creating role", {
            position: "top-right",
            autoClose: 2000,
          });
        }
      }
      }

  };
  useEffect(() => {
    if (roleid) {
      fetchData();
    }
  }, [roleid]);

  const fetchData = async () => {
    try {

      const response = await masterApi.getRoleById(roleid)
      const { roleName, recordStatus, notes } = response?.data?.role;
      role.current = roleName;
      setValue("roleName", roleName || "");
      setValue("recordStatus", recordStatus || "");
      setValue("notes", notes || "");
    } catch (error) {

    } finally {

    }
  };
  return (
    <div className="popup-container large-popup">
      <div className="shadeClose" onClick={closePopup}></div>
      <div className="popup-inner">
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap2">
            {/* <h2>Create Role</h2> */}
            <h2>{viewOnly ? "Role Details" : fromCopy ? "Copy Role Details" : roleid ? "Edit Role Details" : "Create Role"}</h2>
            <button type="button" className="ms-auto close-btn" onClick={closePopup}>
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onFormSubmit)}>
            {isStepperCont1Visible &&
              <div className="steeper-cont-1">
                <div className="stepper-header d-flex align-items-center justify-content-center mb-4">
                  <div className="stepper-info d-flex align-items-center justify-content-center position-relative gap-5">
                    <div className="stepper-btn active">
                      <div className="status-btn-holder">
                        <div className="status-btn"></div>
                      </div>
                      <p className="mb-0">Basic Details</p>
                    </div>
                    <div className="stepper-btn">
                      <div className="status-btn-holder">
                        <div className="status-btn"></div>
                      </div>
                      <p className="mb-0">Permission</p>
                    </div>
                  </div>
                </div>
                <div className="popup-content">
                  <div className="row">
                    {/* Name Field */}
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="name">
                        Role Name <span className="asterisk danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.roleName ? "is-invalid" : ""}`}
                        id="roleName"
                        disabled={viewOnly}
                        {...register("roleName", { required: "Role Name is required" })}
                      />
                      {errors.roleName && <p className="text-danger">{errors.roleName.message}</p>}
                    </div>
                    {/* Status Dropdown */}
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="status">
                        Status <span className="asterisk danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        id="recordStatus"
                        disabled={viewOnly}
                        {...register("recordStatus", { required: "Status is required" })}
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        {Object.entries(RecordStatusEnum).map(([key, value]) => (
                          <option key={key} value={value}>
                            {value}
                          </option>
                        ))}
                      </select>
                      {errors.recordStatus && <p className="text-danger">{errors.recordStatus.message}</p>}
                    </div>
                    <div className="col-12 col-md-12 mb-4">
                      <label className="form-label" >
                        Notes
                      </label>
                      <textarea  disabled={viewOnly} className="form-control h-100" placeholder="Please enter the notes"  {...register("notes")} ></textarea>
                    </div>
                  </div>
                </div>

                {/* Footer with Buttons */}
                <div className="popup-footer position-absolute w-100 d-flex">
                  <div className="ms-auto d-flex gap-3">
                    <button type="button" className="btn btn-dark btn-lg" onClick={closePopup}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-success btn-lg" onClick={nextSection}>
                      Next
                    </button>
                  </div>
                </div>
              </div>
            }
            {isStepperCont2Visible &&
              <div className="steeper-cont-2">
                <div className="stepper-header d-flex align-items-center justify-content-center mb-4">
                  <div className="stepper-info d-flex align-items-center justify-content-center position-relative gap-5">
                    <div className="stepper-btn completed">
                      <div className="status-btn-holder">
                        <div className="status-btn">
                          <IoCheckmarkOutline />
                        </div>
                      </div>
                      <p className="mb-0">Basic Details</p>
                    </div>
                    <div className="stepper-btn active">
                      <div className="status-btn-holder">
                        <div className="status-btn"></div>
                      </div>
                      <p className="mb-0">Permission</p>
                    </div>
                  </div>
                </div>
                <div className="popup-content">
                  <SecondStepperCont setSaveFunction={setSaveFunction} existingdata={roleid}  viewOnly={viewOnly}                  
                                     setPermissionValidator={setPermissionValidator}/>
                </div>

                {/* Footer with Buttons */}
                <div className="popup-footer position-absolute w-100 d-flex">
                  <div className="ms-auto d-flex gap-3">
                    <button type="button" className="btn btn-dark btn-lg" onClick={previousSection}>
                      Back
                    </button>
                    <button type="submit" className="btn btn-success btn-lg" disabled={viewOnly}>
                      {fromCopy || !roleid ? "Submit" : "Update"}
                    </button>
                  </div>
                </div>
              </div>
            }


          </form>
        </div>
      </div>
    </div>
  );
};
